(() => {
  const ROOT_ID = 'amp-preorder';
  const STRONG  = '#amp-preorder strong, #amp-preorder-text, [data-preorder-strong]';
  const esc = (window.CSS && CSS.escape) ? CSS.escape : s => String(s).replace(/[^a-zA-Z0-9_\-]/g, m => '\\' + m);

  function show(el){ if (!el) return; el.removeAttribute('hidden'); el.hidden = false; el.setAttribute('aria-hidden','false'); if (el.style?.display==='none') el.style.display=''; if (el.style?.visibility==='hidden') el.style.visibility=''; }
  function hide(el){ if (!el) return; el.setAttribute('hidden',''); el.hidden = true; el.setAttribute('aria-hidden','true'); }

  async function getCart(maybe){
    if (maybe?.items) return maybe;
    try { return await fetch('/cart.js', { credentials:'same-origin' }).then(r=>r.json()); }
    catch { return null; }
  }

  async function updateFromCart(maybeCart){
    const cart = await getCart(maybeCart);
    const root = document.getElementById(ROOT_ID);
    const strong = document.querySelector(STRONG);
    if (!root || !strong) { console.log('[preorder] missing banner/strong'); return; }

    if (!cart?.items?.length) { strong.textContent=''; hide(root); return; }

    const today = new Date(); today.setHours(0,0,0,0);


    const valid = cart.items.map(line => {
      const id = String(line.id);
      const node = document.querySelector(`input#${esc(id)}[data-ships_on]`);
      const raw  = (node?.dataset?.ships_on || '').trim();
      const d    = raw ? new Date(`${raw}T00:00:00`) : null;
      return { id, raw, d };
    }).filter(r => r.raw && r.d && !Number.isNaN(+r.d) && r.d > today);

    if (valid.length) {
      const latest = valid.reduce((a,b)=> a.d > b.d ? a : b);
      const fmt = latest.d.toLocaleDateString(undefined, { month:'long', day:'numeric' });
      strong.textContent = `This order will ship ${fmt}`;
      show(root);
      console.log('[preorder] future date set →', fmt);
    } else {
      strong.textContent = '';
      hide(root);
    }
  }

  const prevLoaded  = window.AMP_CART_LOADED;
  const prevUpdated = window.AMP_CART_UPDATED;

  window.AMP_CART_LOADED  = function(cart){ updateFromCart(cart); if (typeof prevLoaded  === 'function') return prevLoaded(cart); };
  window.AMP_CART_UPDATED = function(cart){ updateFromCart(cart); if (typeof prevUpdated === 'function') return prevUpdated(cart); };

  if (document.readyState !== 'loading') updateFromCart();
  else document.addEventListener('DOMContentLoaded', () => updateFromCart(), { once:true });
})();
